import './App.css'
import 'antd/dist/reset.css'
import MainScreen from './containers/MainScreen'
import { ConfigProvider } from 'antd'
import useToken from 'antd/es/theme/useToken'
import './styles/antd/spinStyle.css'
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();
function App() {
  const [theme, token] = useToken()
  return (
    <QueryClientProvider client={queryClient}>
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 4,
        },
      }}
    >
      <div className='App'>
        <MainScreen />
      </div>
    </ConfigProvider>
    </QueryClientProvider>
  )
}

export default App
